import { useContext } from "react";
import { LimitContext } from "../contexts/LimitContext";

export function useLimit() {
  const context = useContext(LimitContext);

  return context;
}
